/**
 * gets the version tag for the specified version string
 *
 * @param version - the version string to split
 * @returns the version tag present in the version string or undefined
 */
export function getAirgapVersionTag(version: string): string | undefined {
  return version.split('-').slice(1).join('-').toLowerCase() || undefined;
}
